import React, { createElement } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import RouteListener from "./RouteListener";
import { CSSTransition } from "react-transition-group";

import AssignmentSummary from "./AssignmentSummary";
import AssignmentSlat from "./AssignmentSlat";

require("../../css/components/Assignments.scss");

("use strict");

const PATHWAY_CONDITION = "smoking";

export default class Assignments extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            assignments: null,
            loaded: false,
            loading: false,
            cacheKey: this.props.cacheKey,
            transitionOut: false,
            pathway: {},
            isEnrolledInPathway: false,
            isNoPathwayEnroll: false,
        };

        this.setRouterRef = this.setRouterRef.bind(this);
        this.onAssignmentsClick = this.onAssignmentsClick.bind(this);

        this.onQuestionAnsweredCorrectly = this.onQuestionAnsweredCorrectly.bind(this);
        this.onQuestionAnsweredIncorrectly = this.onQuestionAnsweredIncorrectly.bind(this);
        this.onChangeRadioBtnResponse = this.onChangeRadioBtnResponse.bind(this);
    }

    componentDidMount() {
        this.loadData();
        this.getPathway();
    }

    componentDidUpdate() {
        if (this.props.cacheKey !== this.state.cacheKey) this.loadData();
    }

    loadData() {
        this.setState({
            loading: true,
        });

        if (this.props.assignments != null) {
            this.setState({
                loading: false,
                loaded: true,
                cacheKey: this.props.cacheKey,
                assignments: this.props.assignments,
            });
        } else {
            this.props.user.getAssignments(
                (result) => {
                    this.setState({
                        loading: false,
                        loaded: true,
                        cacheKey: this.props.cacheKey,
                        assignments: result,
                    });
                },
                () => {
                    this.setState({
                        loading: false,
                        loaded: false,
                        cacheKey: this.props.cacheKey,
                    });
                }
            );
        }
    }

    async getPathway() {
        let pathwayData;
        pathwayData = await this.fetchPathway(PATHWAY_CONDITION);
        this.setState({
            pathway: pathwayData,
        });
        return pathwayData;
    }

    async fetchPathway(condition) {
        const url = `/api/assignments/pathway/${condition}`;
        let data = await fetch(url);
        let dataJson = await data.json();
        return dataJson;
    }

    findAssignment(assignmentId) {
        var assignments = this.state.assignments.assignments;
        var a = assignments.findIndex((a) => assignmentId === a.id);

        if (a < 0) return null;
        else return assignments[a];
    }

    verifyAssignmentsComplete(assignments) {
        if (assignments) {
            return assignments.every((a) => a.complete === true);
        }
        return false;
    }

    onQuestionAnsweredCorrectly() {
        var encounter = this.state.assignments;
        var assignment = this.findAssignment(this.props.assignmentId);

        if (assignment)
            this.props.user.reportAssessmentResult(assignment, null, encounter.assessment, true);
    }

    onQuestionAnsweredIncorrectly() {
        var encounter = this.state.assignments;

        var assignment = this.findAssignment(this.props.assignmentId);

        if (assignment)
            this.props.user.reportAssessmentResult(assignment, null, encounter.assessment, false);
    }

    setRouterRef(ref) {
        this.routerRef = ref;
    }

    onAssignmentsClick(e) {
        this.setState({
            transitionOut: true,
        });

        window.setTimeout(() => {
            this.routerRef.history.push(this.props.url);
        }, 10);

        e.preventDefault();
    }

    onChangeRadioBtnResponse(e) {
        let selectedOption = e.target.value;
        let updatedPathway;
        updatedPathway = { ...this.state.pathway };
        const { pathwayQuestion } = updatedPathway;
        if (selectedOption === "yes") {
            pathwayQuestion.action.answer = 1;
            this.setState({ isEnrolledInPathway: true });
        }
        if (selectedOption === "no") {
            pathwayQuestion.action.answer = 0;
            this.setState({ isNoPathwayEnroll: true });
        }
        this.setState({ ...updatedPathway });
        this.props.user.triggerPathway(updatedPathway.id, updatedPathway);
    }

    renderItems(assignmentId, items, keyPrefix) {
        var assets = [];

        for (var i in items) {
            var item = items[i];
            assets.push(
                React.createElement(AssetSlat, {
                    key: keyPrefix + i,
                    parentKey: keyPrefix + i,
                    asset: item.asset,
                    urlHash: this.props.urlHash,
                    languageNames: this.props.languageNames,
                    assignmentId: assignmentId,
                    assignment: item,
                    copy: this.props.copy,
                    languageCode: this.props.languageCode,
                })
            );
        }

        return React.createElement(
            "ul",
            {
                key: keyPrefix,
                className: "assetList",
            },
            assets
        );
    }

    renderAssignments(keyPrefix) {
        var assignments = this.state.assignments.assignments;
        var children = [];
        const { pathwayQuestion } = this.state.pathway;

        children.push(
            React.createElement(
                "h2",
                { key: keyPrefix + "-h" },
                this.props.copy.assignedOn /* + ' ' + this.state.assignments.dateTime */
            ),
            [
                !this.state.isNoPathwayEnroll && this.verifyAssignmentsComplete(assignments) ? (
                    React.createElement(
                        "div",
                        {
                            className: "assignmentSummary",
                        },
                        [
                            this.state.isEnrolledInPathway
                                ? createElement(
                                      "p",
                                      {},
                                      `You've been enrolled in a new pathway program`
                                  )
                                : createElement(
                                      "p",
                                      {},
                                      pathwayQuestion ? pathwayQuestion.eng : ""
                                  ),
                        ],
                        [
                            !this.state.isEnrolledInPathway &&
                                createElement(
                                    "div",
                                    {
                                        className: "pathwayResponse",
                                        onChange: this.onChangeRadioBtnResponse,
                                    },
                                    React.createElement("input", {
                                        type: "radio",
                                        id: "yes-response-btn",
                                        value: "yes",
                                        name: "choice",
                                    }),
                                    React.createElement(
                                        "label",
                                        { id: "yes-response-label" },
                                        "Yes"
                                    ),
                                    React.createElement("input", {
                                        type: "radio",
                                        id: "no-response-btn",
                                        value: "no",
                                        name: "choice",
                                    }),
                                    React.createElement("label", { id: "no-response-label" }, "No")
                                ),
                        ]
                    )
                ) : (
                    <></>
                ),
            ],
            React.createElement(Route, {
                key: keyPrefix + "-r",
                path: "/",
                component: RouteListener,
            })
        );

        for (var a in assignments) {
            var assignment = assignments[a];
            children.push(
                React.createElement(AssignmentSlat, {
                    key: keyPrefix + a,
                    parentKey: keyPrefix + a,
                    assignment: assignment,
                    url: this.props.url,
                    urlHash: this.props.urlHash,
                    copy: this.props.copy,
                    languageCode: this.props.languageCode,
                })
            );
        }

        var ul = React.createElement(
            "ul",
            {
                className: "assetList",
            },
            children
        );

        return React.createElement(Router, { key: keyPrefix }, ul);
    }

    renderAssignment(assignmentId) {
        var assignments = this.state.assignments.assignments;

        var children = [];

        children.push([
            React.createElement(Route, {
                key: "r",
                path: "/",
                component: RouteListener,
            }),
            React.createElement(
                "h2",
                { key: "h" },
                React.createElement(
                    "a",
                    { key: "ah", onClick: this.onAssignmentsClick },
                    this.props.copy
                        .backToAssignmentsFrom /* + ' ' + this.state.assignments.dateTime */
                )
            ),
        ]);

        for (var a in assignments) {
            var assignment = assignments[a];

            children.push(
                React.createElement(
                    CSSTransition,
                    {
                        key: a + "-slat",
                        classNames: "assignment-title-hidden",
                        in: assignment.id !== assignmentId,
                        timeout: 500,
                    },
                    React.createElement(AssignmentSlat, {
                        key: "at-" + assignment.id,
                        className: assignment.id !== assignmentId ? "assignment-title-hidden" : "",
                        parentKey: assignment.id,
                        assignment: assignment,
                        copy: this.props.copy,
                        languageCode: this.props.languageCode,
                    })
                )
            );
            if (assignment.id === assignmentId)
                children.push([
                    React.createElement(
                        CSSTransition,
                        {
                            key: a,
                            classNames: "assignment",
                            in: true,
                            appear: true,
                            timeout: 500,
                        },
                        React.createElement(
                            "div",
                            { key: "a-" + assignment.id, className: "assignment" },
                            [
                                React.createElement(AssignmentSummary, {
                                    key: a + "-s",
                                    copy: this.props.copy,
                                    encounter: this.state.assignments,
                                    assignment: assignment,
                                    url: this.props.url,
                                    urlHash: this.props.urlHash,
                                    onQuestionAnsweredCorrectly: this.onQuestionAnsweredCorrectly,
                                    onQuestionAnsweredIncorrectly:
                                        this.onQuestionAnsweredIncorrectly,
                                    languageCode: this.props.languageCode,
                                    libraryUrl: this.props.libraryUrl,
                                }),
                                this.renderItems(assignment.id, assignment.items, a + "-"),
                            ]
                        )
                    ),
                ]);
        }

        var ul = React.createElement(
            "ul",
            {
                className: "assetList",
            },
            children
        );

        return React.createElement(Router, { key: assignmentId, ref: this.setRouterRef }, ul);
    }

    render() {
        if (this.state.loading) return "Loading...";

        if (!this.state.loaded) return "Loading failed.";

        return React.createElement(
            "div",
            { className: "assignments" },
            this.state.assignments.assignments.length
                ? this.props.assignmentId
                    ? this.renderAssignment(this.props.assignmentId)
                    : this.renderAssignments("a-")
                : "No Assignments found for this Encounter."
        );
    }
}
